var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWeatherRainy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 61,
    viewBox: "0 0 68 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_754_1553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8301 37.1392C52.7201 37.1392 57.4901 32.3692 57.4901 26.4792C57.4901 20.5892 52.7201 15.8192 46.8301 15.8192C46.7901 15.8192 46.7601 15.8192 46.7201 15.8192C45.7801 7.30922 38.5701 0.699219 29.8101 0.699219C22.8901 0.699219 16.9501 4.82922 14.2801 10.7492C14.2001 10.7492 14.1101 10.7492 14.0301 10.7492C6.74008 10.7392 0.830078 16.6492 0.830078 23.9392C0.830078 31.2292 6.74008 37.1392 14.0301 37.1392",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0502 37.14C64.7502 37.14 67.7502 34.14 67.7502 30.44C67.7502 26.74 64.7502 23.74 61.0502 23.74C61.0302 23.74 61.0002 23.74 60.9802 23.74C60.3802 18.4 55.8602 14.25 50.3602 14.25C46.0202 14.25 42.2802 16.84 40.6102 20.56C40.5602 20.56 40.5002 20.56 40.4502 20.56C35.8702 20.56 32.1602 24.27 32.1602 28.85C32.1602 33.43 35.8702 37.14 40.4502 37.14",
    fill: "url(#paint0_linear_754_1553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4692 53.4893C10.1292 53.4893 9.78924 53.3993 9.46924 53.2193C8.50924 52.6693 8.18924 51.4393 8.73924 50.4893L11.6292 45.4893C12.1792 44.5293 13.3992 44.1993 14.3592 44.7593C15.3192 45.3093 15.6392 46.5393 15.0892 47.4893L12.1992 52.4893C11.8292 53.1293 11.1592 53.4893 10.4692 53.4893Z",
    fill: "url(#paint1_linear_754_1553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5806 53.4893C26.2406 53.4893 25.9006 53.3993 25.5806 53.2193C24.6206 52.6693 24.3006 51.4393 24.8506 50.4893L27.7406 45.4893C28.2906 44.5293 29.5106 44.1993 30.4706 44.7593C31.4306 45.3093 31.7506 46.5393 31.2006 47.4893L28.3106 52.4893C27.9406 53.1293 27.2706 53.4893 26.5806 53.4893Z",
    fill: "url(#paint2_linear_754_1553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6997 53.4893C42.3597 53.4893 42.0197 53.3993 41.6997 53.2193C40.7397 52.6693 40.4197 51.4393 40.9697 50.4893L43.8597 45.4893C44.4097 44.5293 45.6297 44.1993 46.5897 44.7593C47.5497 45.3093 47.8697 46.5393 47.3197 47.4893L44.4297 52.4893C44.0597 53.1293 43.3897 53.4893 42.6997 53.4893Z",
    fill: "url(#paint3_linear_754_1553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4692 60.669C15.1292 60.669 14.7892 60.579 14.4692 60.399C13.5092 59.849 13.1892 58.619 13.7392 57.669L16.6292 52.669C17.1792 51.709 18.3992 51.379 19.3592 51.939C20.3192 52.489 20.6392 53.719 20.0892 54.669L17.1992 59.669C16.8292 60.309 16.1592 60.669 15.4692 60.669Z",
    fill: "url(#paint4_linear_754_1553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0806 60.669C31.7406 60.669 31.4006 60.579 31.0806 60.399C30.1206 59.849 29.8006 58.619 30.3506 57.669L33.2406 52.669C33.7906 51.709 35.0106 51.379 35.9706 51.939C36.9306 52.489 37.2506 53.719 36.7006 54.669L33.8106 59.669C33.4406 60.309 32.7706 60.669 32.0806 60.669Z",
    fill: "url(#paint5_linear_754_1553)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6997 60.669C48.3597 60.669 48.0197 60.579 47.6997 60.399C46.7397 59.849 46.4197 58.619 46.9697 57.669L49.8597 52.669C50.4097 51.709 51.6297 51.379 52.5897 51.939C53.5497 52.489 53.8697 53.719 53.3197 54.669L50.4297 59.669C50.0597 60.309 49.3897 60.669 48.6997 60.669Z",
    fill: "url(#paint6_linear_754_1553)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_754_1553",
    x1: 39.5802,
    y1: 39.7,
    x2: 59.9002,
    y2: 19.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1EEF9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_754_1553",
    x1: 8.46924,
    y1: 48.9893,
    x2: 15.3592,
    y2: 48.9893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_754_1553",
    x1: 24.5906,
    y1: 0.699311,
    x2: 31.4706,
    y2: 0.699311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_754_1553",
    x1: 40.6997,
    y1: 0.699311,
    x2: 47.5797,
    y2: 0.699311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_754_1553",
    x1: 13.4692,
    y1: 56.169,
    x2: 20.3592,
    y2: 56.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_754_1553",
    x1: 30.0906,
    y1: 56.169,
    x2: 36.9706,
    y2: 56.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_754_1553",
    x1: 46.6997,
    y1: 56.169,
    x2: 53.5797,
    y2: 56.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BDF2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_754_1553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.92,
    height: 59.97,
    fill: "white",
    transform: "translate(0.830078 0.699219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherRainy);
export default __webpack_public_path__ + "static/media/icon_weather_rainy.59a1d8ddb03ede48666ad326b635048c.svg";
export { ForwardRef as ReactComponent };